<template>
  <!--
    icon="mdi-vuetify"
  -->
  <base-section id="about-us">
    <!--
    <base-section-heading
      color="grey lighten-2"
      title="About Us"
    />
    -->
    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>

    <span class="trace">AboutUs.vue</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutUs',

    data: () => ({
      cards: [
        {
          title: 'Our Mission',
          subtitle: '',
          text: 'We provide information about local environmental issues and resources and organize practical projects aimed at reducing Truro’s collective carbon footprint and safeguarding Truro’s ecosystems.',
          text_prior_version_20200710: 'We provide information about local environmental issues and resources and organize practical projects aimed at reducing Truro’s collective carbon footprint and safeguarding the ecosystems of Truro’s water and land.',
          callout: '',
        },
        {
          title: 'Our Vision',
          subtitle: '',
          text: 'We envision a resilient, ecologically healthy, environmentally responsible community living without pollutants in our air, water, and land.',
          callout: '',
        },
        {
          title: 'Our Values',
          subtitle: '',
          html: '<ul><li>We are a grassroots, informal organization, inviting all interested members of the community to participate in our work.</li><li>We are committed to educating ourselves about the local impact of climate change and to finding environmentally responsible solutions.</li><li>We are committed to social justice, focusing on the consequences of climate change and environmental actions for all members of the community.</li><li>We are committed to green development and a strong local economy benefiting local businesses and workers producing food, goods, and services.</li>',
          callout: '',
        },

      ],
    }),
  }

        /*
We are a grassroots, informal organization, inviting all interested members of the community to participate in our work.
We are committed to educating ourselves about the local impact of climate change and to finding environmentally responsible solutions.
We are committed to social justice, focusing on the consequences of climate change and environmental actions for all members of the community.
We are committed to green development and a strong local economy benefiting local businesses and workers producing food, goods, and services.

        {
          title: 'Target Setting',
          subtitle: 'Income Flow',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '03',
        },
        */

</script>
